import environment from "./environment";


export function createClient<T>(factoryFunc: (any) => T, config?: any, _basePath?: any, _axios?: any) {
    let c = {
        basePath: environment.personaApiBaseUrl
    };
    if (config) {
        c = { ...config, ...c};
    }

    return factoryFunc(c);
}